<template>
    <CustomHeader :text="$t('activityName.daily_first_recharge')" />
    <div class="bannerContainer">
        <img :src="dataSet.bannerIcon" alt="">
    </div>
    <div class="recharge_content">
        <div class="recharge_container">
            <div class="subContainer">
                <div class="day_num" v-for="(item, index) in dataSet.configList" :key="index" @click="selectTab(item)">
                    <div class="numberText" :style="{
                        backgroundImage: dataSet.selectedTabData?.day === item?.day
                            ? `url(${require('@/assets/firstRecharge/tab_select.png')})`
                            : `url(${require('@/assets/firstRecharge/frch_tab_default.png')})`
                    }" :class="dataSet.selectedTabData?.day === item?.day ? 'activeNumText' : ''">{{ item?.day }}</div>
                    <div class="selectIcon">
                        <img v-if="dataSet.selectedTabData?.day === item?.day" src="@/assets/firstRecharge/frch_tab_jiantou.png"
                            alt="">
                        <div v-else style="padding-bottom:15px ;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detailsCard">
            <van-row class="cardTitle">
                <van-col span="2" class="titleImage">
                    <img src="@/assets/firstRecharge/frch_title_icon.png" alt="">
                </van-col>
                <van-col span="20" style="padding-left:5px;">{{ $t('activity.firstDepositTitle') }}</van-col>
                <van-col span="24" class="textImage">
                    <img v-if="dataSet.selectedTabData?.activeStatus === 1 && dataSet.isRewardEligible"
                        src="@/assets/firstRecharge/frch_sttaus_notstart.png" alt="">
                    <img v-else src="@/assets/firstRecharge/frch_status_unactivated.png" alt="">
                </van-col>
            </van-row>

            <div class="tableContainer">
                <van-row class="tableHead">
                    <van-col span="12" class="tableTitle" style="border-right: 1px solid #998ba18a;">{{
                        $t('activity.depositAmount') }}</van-col>
                    <van-col span="12" class="tableTitle">{{ $t('activity.additionalBonus') }}</van-col>
                </van-row>
                <div style="padding: 0 20px;" v-for="(item, i) in dataSet.selectedTabData?.recharge_config" :key="i">
                    <van-row style="border-bottom: 1px solid #998ba18a; ">
                        <van-col span="12" class="tableTitle tabelValue1">R$ <span>{{ item?.amount
                                }}</span></van-col>
                        <van-col span="12" class="tableTitle tabelValue2">R$ <span>{{ item?.credits
                                }}</span></van-col>
                    </van-row>
                </div>
                <div class="depositBtnContainer">
                    <div class="statusButton" v-if="dataSet.selectedTabData?.record">
                        <p v-if="setActivityStatus() == 0" style="color: #0484ff;">{{
                            $t('activityStatus.pending') }}</p>
                        <p v-else-if="setActivityStatus() == 1" style="color: #36d836;">{{
                            $t('activityStatus.completed')
                            }}</p>
                        <p v-else-if="setActivityStatus() == 2" style="color: #ff0000;">{{
                            $t('activityStatus.noRewards')
                            }}</p>
                        <p v-else style="color: #ff0000;">{{ $t('activity.overdue')
                        }}</p>
                    </div>
                    <div v-else
                        :class="dataSet.selectedTabData?.activeStatus === 1 && dataSet.isRewardEligible ? 'depositBtn' : 'deposit-disabled'"
                        @click="goToDeposit">
                        {{ $t('activity.immediateDeposit') }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom_text" v-if="dataSet.activityInfo?.length > 0">
        <van-row style="padding-bottom: 10px;">
            <van-col span="6" class="">
                <div class="line1"></div>
            </van-col>
            <van-col span="12" class="title">
                <div>{{ $t('common.activityTitle') }}</div>
            </van-col>
            <van-col span="6" class="">
                <div class="line2"></div>
            </van-col>
        </van-row>
        <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
            {{ item }}
        </div>
    </div>
</template>
<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import {defineProps,defineEmits } from 'vue';
import { FirstDepositData } from '@/view/firstDeposit/newFirstRecharge';

const props = defineProps<{
    dataSet: FirstDepositData
}>()
const emits = defineEmits(['goToDeposit','selectTab'])

const goToDeposit = () => {
     emits("goToDeposit")
}

const setActivityStatus = () => {
    return props.dataSet.selectedTabData.record?.status
}

const selectTab = (item: any) => {
    emits("selectTab",item)
}

</script>
<style scoped>
.bannerContainer img {
    width: 100%;
}

.bannerContainer {
    padding-top: 50px;
}

.recharge_content {
    padding: 0 25px;
}

.recharge_container {

    background-image: linear-gradient(to bottom, #2a2a2ac9, #feb47b00);
    padding: 10px 15px 0;
    border-radius: 15px;

}

.recharge_container::-webkit-scrollbar {
    display: none;
}

.subContainer {
    max-width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.day_num {
    position: relative;
    flex: 0 0 auto;
    justify-content: center;
    width: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.day_num img {
    width: 100%;
}

.numberText {
    color: #D17FFF;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-repeat: repeat;
    width: 55px;
    height: 55px;
}

.activeNumText {
    color: #DA009B;
}

.selectIcon {
    display: flex;
    justify-content: center;
}

.selectIcon img {
    height: 15px;
    width: 20px;
}

.detailsCard {
    background-image: linear-gradient(180deg, rgba(44, 50, 56, 0.50) 0%, rgba(32, 38, 45, 0.25) 99%);
    border: 1px solid rgba(249, 196, 134, 0.50);
    border-radius: 15px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 15px 15px;
}

.cardTitle {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 15px;
    padding: 10px 0;
}

.titleImage img {
    width: 85%;
}

.textImage img {
    width: 100%;
}

.tableContainer {
    border-radius: 15px;
    background-image: linear-gradient(180deg, rgba(209, 127, 255, 0.50) 2%, rgba(127, 153, 255, 0.50) 100%);
    border: 1px solid #F9C486;
    padding-bottom: 10px;
}

.tableHead {
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    color: #FFFFFF;
    padding: 10px;
}

.tableTitle {
    display: flex;
    justify-content: center;
    text-align: center;
}

.tabelValue1,
.tabelValue2 {
    padding: 10px;
    color: #ffffff73;
    display: flex;
    align-items: center;
}

.tabelValue1 span {
    font-weight: bold;
    color: #fff;
    font-size: 16px;
    padding: 0 10px;
}

.tabelValue2 span {
    font-weight: bold;
    color: #FFEE00;
    font-size: 16px;
    padding: 0 10px;
}

.depositBtnContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
}

.statusButton {
    font-size: 15px;
    font-weight: bold;
    background: #514e4e45;
    border-radius: 10px;
    border: 1px solid #ffffff4d;
    width: 100%;
}

.statusButton p {
    margin: 10px 0;
}

.depositBtn {
    color: #000;
    background-image: linear-gradient(99deg, #FCD7A1 0%, #D17836 100%);
    border-radius: 10px;
    padding: 10px;
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}

.deposit-disabled {
    color: rgba(255, 255, 255, 0.25);
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: none;
    border-radius: 10px;
    padding: 10px;
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

@media(min-width: 450px) {
    .numberText {
        width: 65px;
        height: 65px;
    }
}

@media(max-width: 350px) {
    .numberText {
        width: 50px;
        height: 50px;
    }
}
</style>